import { render, staticRenderFns } from "./GridContainerItem.vue?vue&type=template&id=1f0f6d2a&scoped=true&"
import script from "./GridContainerItem.vue?vue&type=script&lang=js&"
export * from "./GridContainerItem.vue?vue&type=script&lang=js&"
import style0 from "./GridContainerItem.vue?vue&type=style&index=0&id=1f0f6d2a&lang=scss&scoped=true&"
import style1 from "./GridContainerItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f6d2a",
  null
  
)

export default component.exports